import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { APIHandler, AddFavorite, Image, LinkHandler, DataHandler } from 'C4';

const normalizeProps = async ({ type, unid, content }) => {
  if (type === 'p') {
    const { chapter, image, page, subtitle, title } = content;

    return {
      id: unid,
      image,
      subtitle,
      title,
      type: 'retain',
      url: ['retain', chapter, (page - 1).toString()].join('/').replace(/\/\//g, '/'),
    };
  }

  const match =
    ((await APIHandler[type === 'f' ? 'getFastFacts' : 'getToolbox'](DataHandler.matchAppIdSync())) || []).find(
      ({ id }) => id.toString() === unid,
    ) || {};

  const { image, subtitle, title, type: contentType, url } = match;

  return {
    id: unid,
    image,
    subtitle,
    title,
    type: contentType,
    url,
  };
};

const getNormalizedProps = async (props, callback) => callback(await normalizeProps(props));

const FavoriteLink = ({ type: viewType, unid, content }) => {
  const [normalizedProps, setNormalizedProps] = useState({});
  const { image, subtitle, title, type, url, id } = normalizedProps;

  useEffect(() => {
    getNormalizedProps({ type: viewType, unid, content }, setNormalizedProps);
  }, [viewType, unid, content]);

  return (
    Object.keys(normalizedProps).length > 0 && (
      <div className="favorite__card">
        <AddFavorite viewType={viewType} upID={unid} color />
        <LinkHandler url={url} type={type} id={id} className="favorite__button">
          {title.length > 0 && <h4>{title}</h4>}
          {subtitle.length > 0 && <p>{subtitle}</p>}
          <Image src={image} alt="placeholder thumbnail" />
        </LinkHandler>
      </div>
    )
  );
};

export default FavoriteLink;

FavoriteLink.propTypes = {
  type: PropTypes.string,
  unid: PropTypes.string,
  content: PropTypes.shape(),
};

FavoriteLink.defaultProps = {
  type: null,
  unid: null,
  content: {},
};
